// Service page content for Skilled Employer Sponsored Regional (Subclass 494).
// Sourced from docs/research/australian-visa-pathways.md §2.
// COMPLIANCE: we are not a registered migration agent and do not give migration
// advice or assess eligibility; the regulated advice and lodgement are a
// registered migration agent's. No guaranteed outcomes; honest about provisional
// status and the 191 conditions; no unverified figures stated as fact. "Who does
// what" disclosure and disclaimer are rendered by the shared page template.

const regional494 = {
  groupSlug: "employer-sponsored",
  slug: "regional-494",
  title: "Skilled Employer Regional visa (Subclass 494)",
  eyebrow: "Employer Sponsored",
  intro:
    "The Subclass 494 lets a regional Australian employer sponsor a skilled worker for a position in a designated regional area. It is a provisional visa valid for 5 years and, once the regional and income conditions are met, it is a pathway to permanent residence through the Subclass 191.",

  chips: [
    { label: "Visa type", value: "Provisional, 5 years" },
    { label: "Sponsor", value: "Regional employer" },
    { label: "Location", value: "Designated regional area" },
    { label: "Leads to", value: "Permanent residence via the 191" },
  ],

  whoFor: [
    "Skilled workers with a regional employer ready to sponsor them.",
    "People open to living and working in regional Australia.",
    "Applicants comfortable with a provisional visa first, then permanent residence via the 191.",
  ],

  essentials: [
    {
      title: "A regional employer nomination",
      detail:
        "An approved employer must nominate you for a position located in a designated regional area.",
    },
    {
      title: "A positive skills assessment",
      detail:
        "You generally need a skills assessment for your nominated occupation, which must be on the applicable list.",
    },
    {
      title: "Relevant work experience",
      detail:
        "Typically several years of relevant experience in the occupation is required.",
    },
    {
      title: "Under 45 and competent English",
      detail:
        "An age limit and English requirement apply, with some exemptions.",
    },
    {
      title: "A commitment to the region",
      detail:
        "You must live and work in the designated regional area while you hold the visa.",
    },
    {
      title: "An eye on the 191",
      detail:
        "Meeting the regional-residence and minimum-income conditions is what unlocks permanent residence later.",
    },
  ],

  process: [
    {
      title: "Confirm eligibility",
      detail:
        "A registered migration agent checks the occupation, the region, and your experience against the 494 requirements. We organise the documents behind it.",
    },
    {
      title: "Skills assessment",
      detail:
        "We assemble and prepare the evidence to obtain a positive assessment from the right assessing authority.",
    },
    {
      title: "Guide the employer nomination",
      detail:
        "We help the regional employer organise the sponsorship and nomination paperwork, and a registered migration agent advises on their obligations.",
    },
    {
      title: "Lodge the visa application",
      detail:
        "We prepare a thorough file. A registered migration agent lodges the application and deals with the Department.",
    },
    {
      title: "Plan the 191 transition",
      detail:
        "Once granted, we help you organise and track the residence and income records needed for permanent residence.",
    },
  ],

  faqs: [
    {
      q: "How is the 494 different from the 482?",
      a: "Both are employer-sponsored, but the 494 is specifically for regional positions, runs for 5 years, and leads to permanent residence through the 191 once you meet the regional and income conditions. The 482 is not region-specific and leads to PR through the 186.",
    },
    {
      q: "Where counts as regional?",
      a: "A designated regional area, which covers most of Australia outside the largest cities. A registered migration agent confirms whether your employer's location qualifies before you rely on it.",
    },
    {
      q: "How do I get permanent residence?",
      a: "Through the Subclass 191, after living in a designated regional area and meeting a minimum taxable income requirement for the required period while holding the 494. We help you organise and keep the records so you stay on track for it.",
    },
    {
      q: "What if the conditions are not met?",
      a: "Falling short of the regional-residence or income requirements can affect your move to permanent residence, so it is important to plan from the start. A registered migration agent walks you through the conditions honestly before you commit.",
    },
  ],

  related: [
    "skills-in-demand-482",
    "employer-nomination-186",
    "permanent-regional-191",
  ],

  lastVerified: "13 July 2026",
};

export default regional494;
